<template>
    <div class="container grid">
        <PageHero v-bind="heroData" />
        <div class="grid grid-cols-12">
            <div class="col-span-12 flex flex-col gap-4 lg:col-span-4 lg:row-span-2 lg:gap-6">
                <aside v-if="contactFormData?.aside.faq" class="tile tile-blur">
                    <h3 class="font-title mb-4 text-xl">{{ contactFormData.aside.faq.title }}</h3>
                    <p>{{ contactFormData.aside.faq.description }}</p>
                </aside>
                <aside v-if="contactFormData?.aside.companyInformation" class="tile tile-blur">
                    <div class="mb-4">
                        <h3 class="font-title mb-4 text-xl">
                            {{ contactFormData.aside.companyInformation.company }}
                        </h3>
                        <p>{{ contactFormData.aside.companyInformation.contactUs }}</p>
                    </div>
                    <hr class="border-t-0 border-b border-white/20" />
                    <div class="mt-4">
                        <h4>{{ $t('common.contactInfoLabel') }}</h4>
                        <ul>
                            <li
                                v-for="link in contactFormData.aside.companyInformation
                                    .contactLinks"
                                :key="link.url">
                                <NuxtLink class="btn-tertiary-a inline-button" :to="link.url">{{
                                    link.title
                                }}</NuxtLink>
                            </li>
                        </ul>
                    </div>
                </aside>
            </div>
            <div class="col-span-12 grid lg:col-span-8">
                <ContactForm v-if="contactFormData?.form" v-bind="contactFormData.form" />
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import type {
    ContactFormComponentModel,
    ContactPageContentItem,
    HeroComponentModel,
} from '@su4r-frontend/api';

const { data } = defineProps<{
    data: ContactPageContentItem;
}>();

const heroData = data.components.find(
    (comp): comp is HeroComponentModel => comp.alias === 'heroComponent'
);

const contactFormData = data.components.find(
    (comp): comp is ContactFormComponentModel => comp.alias === 'contactForm'
);
</script>
